import { SendingPlatform } from 'modules/sendingPlatforms/constants';
import { EmptyStateWithContainer } from 'ui/emptyState';
import { ProvisionedEmptyState } from 'ui/illustrations';
import { WebLink } from 'ui/theme';
import { iterableLoveText } from '../../../utils';
import { useMetadata } from '../../../hooks';

export const EmailAccountsEmptyState = ({
  sendingPlatform,
}: {
  sendingPlatform: SendingPlatform;
}) => {
  const { name, supportLink } = useMetadata(sendingPlatform);

  return (
    <EmptyStateWithContainer
      Illustration={ProvisionedEmptyState}
      title={iterableLoveText(name)}
      subtitle={
        <span>
          Don’t have a {name} account? We can{' '}
          <WebLink href={supportLink} target="_blank">
            set one up for you
          </WebLink>
          .
        </span>
      }
    />
  );
};
